var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","ripple":false},on:{"click":function($event){_vm.leftMenu = !_vm.leftMenu}}},[_c('v-icon',{attrs:{"color":_vm.additionalBtnColor}},[_vm._v(" mdi-menu ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }